export enum GetPatientListFormFields {
  SearchWord = 'searchWord',
  Sex = 'sex',
}

export type TAgreeParticipationForm = {
  isAgree: string;
};

export enum PatientInfoSex {
  Male = '남성',
  Female = '여성',
}

export enum PatientInfoSortByFormLabel {
  Name = '대상자',
  BirthAndAge = '생년월일(만 연령)',
  Sex = '성별',
  Occupation = '직업',
  Relation = '학생과의 관계',
  CreatedAt = '등록일시',
}
